import { SET_EDITTING_COMPANY, UPDATE_FUNDING_BY_ID, DELETE_FUNDING_BY_ID, DELETE_EMPLOYEE_BY_ID, UPDATE_EMPLOYEE_BY_ID } from "../actions/actiontypes";

const initialState = {
  data: {},
  funding: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_EDITTING_COMPANY:
      return {
        ...state,
        data: action.payload,
        // funding: action.payload.funding
      }
    case UPDATE_FUNDING_BY_ID:
      return state
    case DELETE_FUNDING_BY_ID:
      return state
    case UPDATE_EMPLOYEE_BY_ID:
      return state
    case DELETE_EMPLOYEE_BY_ID:
      return state
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/src/reducers/Company.js